import React from "react";
import classes from './News.module.scss'



const News = () => {
  return (
    <nav className={classes.chat}>
      News
    </nav>
  );
}

export default News;